<template>
  <div
    class="file"
    :class="{ 'has-name': hasName, 'is-disabled': disabled }"
    v-bind="$attrs">

    <label class="file-label">

      <input
        :multiple="multiple"
        :disabled="disabled"
        class="file-input"
        type="file"
        @change="onFileChange($event.target.files)"
        :required="required">

      <span class="file-cta">
        <span class="file-icon">
          <i class="fas fa-upload"></i>
        </span>
        <span 
          class="file-label" v-if="!fileName || hasName">
          {{ placeholder }}
        </span>
        <span class="file-label" v-else>
          {{ fileName }}
        </span>
      </span>

      <span class="file-name" v-if="hasName">
        <span v-if="fileName">
          {{ fileName }}  
        </span>
        <span v-else>No file selected</span>
      </span>

    </label>

  </div>
</template>

<script>
export default {
  name: 'file-input',
  props: {
    value: {
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    fileTypeValidator: {
      type: String,
      default: 'image.*'
    },
    hasName: {
      type: Boolean,
      default: false
    },
    maxSize: {
      default: 3072,
      type: Number
    },
    required: {
      type: Boolean
    },
    placeholder: {
      type: String,
      default: 'Choose a file...'
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    hooks() {
      return {
        ...this.$listeners
      };
    },
    fileName() {
      return this.value ? this.value.name : null;
    },
    maxMbs() {
      return this.maxSize / 1024;
    }
  },
  methods: {
    onFileChange(files) {
      if (files.length > 1) {
        alert('Please select one file only');
      } else {
        let file = files[0];

        if (this.fileSizeValidator(file)) {
          if (!file.type.match(this.fileTypeValidator)) {
            alert('Please choose a file type that matches ' + this.fileTypeValidator);
          } else {
            const imageURL = this.fileTypeValidator == 'image.*' ?
              URL.createObjectURL(file) : null;
            this.$emit('input', { file: file, name: file.name, url: imageURL });
          }
        } else {
          alert(`Your file is too big! Please select an image under ${this.maxMbs} MBs`);
        }
      }
    },
    fileSizeValidator(file) {
      const { maxSize } = this;
      let size = file.size / maxSize / maxSize;
      return size < 1;
    }
  }
}
</script>

<style scoped>
.is-disabled {
  opacity: 0.8;
  cursor: not-allowed;
}
</style>
